export const END_USER_TPA_FLOW_SESSION_KEY = 'spence_end_user_tpa_flow';

export function markEndUserTpaFlowActive(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(END_USER_TPA_FLOW_SESSION_KEY, 'true');
}

export function isEndUserTpaFlowActive(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.sessionStorage.getItem(END_USER_TPA_FLOW_SESSION_KEY) === 'true';
}

export function clearEndUserTpaFlow(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.removeItem(END_USER_TPA_FLOW_SESSION_KEY);
}
